import { Link, useNavigate } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { CardMedia, Grid, Stack, Typography, useMediaQuery } from '@mui/material';

// project imports
import AuthWrapper1 from '../AuthWrapper1';
import AuthCardWrapper from '../AuthCardWrapper';
// import Logo from 'ui-component/Logo';
// import AuthRegister from '../auth-forms/AuthRegister';
import AuthFooter from 'ui-component/cards/AuthFooter';
import logo from '../../../../assets/images/logos/Group 1000002184.svg'
import ForgetPasswordForm from '../auth-forms/ForgetPasswordForm';
import AgentCodeDialog from './Components/ForgetPasswordDialog';
import { useState } from 'react';
import { PostGetOtp } from 'API/ForgetPassword/api';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import { useEffect } from 'react';
// assets

// ===============================|| AUTH3 - REGISTER ||=============================== //

const ForgetPassword = () => {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
  const [Open, setOpen] = useState(true)
  const [agCode, setAgCode] = useState(null)

  const [isLoading, setIsLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null)
  const [alertType, setAlertType] = useState('success')
  const [alertOpen, setAlertOpen] = useState(false)
  const navigate=useNavigate()

  const handleClose = () => {
    setOpen(false)
  }

  const handleCloseAlert = () => {
    setAlertOpen(false)
  }

  const handleCodeSubmit = () => {
    PostGetOtp(agCode, setAlertMessage, setAlertType, setAlertOpen, setIsLoading, handleClose)
  }

  useEffect(() => {
    if (sessionStorage.getItem('isReloaded')) {
      navigate(-1); 
    } else {
      sessionStorage.setItem('isReloaded', 'true');
    }
    return () => {
      sessionStorage.removeItem('isReloaded');
    };
  }, [navigate]);

  return (
    <AuthWrapper1>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar anchorOrigin={{horizontal:'right',vertical:'top'}} open={alertOpen} autoHideDuration={6000} onClose={handleCloseAlert}>
        <Alert
          onClose={handleCloseAlert}
          severity={alertType}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
      <AgentCodeDialog loading={isLoading} open={Open} code={agCode} setCode={setAgCode} handleSubmit={handleCodeSubmit} />
      <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
        <Grid item xs={12}>
          <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
            <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
              <AuthCardWrapper>
                <Grid container spacing={2} alignItems="center" justifyContent="center">
                  {/* <Grid item sx={{}}> */}
                  <Link to="#">
                    {/* <Logo /> */}
                    {/* <Typography color={theme.palette.secondary.main} gutterBottom variant={matchDownSM ? 'h3' : 'h2'}>
                            Network Manager
                          </Typography> */}
                    <CardMedia component='img' image={logo} alt='logo' width='20%' />
                  </Link>
                  {/* </Grid> */}
                  <Grid item xs={12}>
                    <Grid container direction={matchDownSM ? 'column-reverse' : 'row'} alignItems="center" justifyContent="center">
                      <Grid item>
                        <Stack alignItems="center" justifyContent="center" spacing={1}>
                          <Typography color={theme.palette.secondary.main} gutterBottom variant={matchDownSM ? 'h3' : 'h3'}>
                            Change Password
                          </Typography>
                          {/* <Typography variant="caption" fontSize="16px" textAlign={matchDownSM ? 'center' : 'inherit'}>
                            Enter your credentials to continue
                          </Typography> */}
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <ForgetPasswordForm phone={agCode}/>
                  </Grid>
                  
                  <Grid item xs={8}>
                    <Grid item container direction="column" xs={12} textAlign='center'>
                      {/* <Typography component={Link} to="/Login" variant="subtitle1" sx={{ textDecoration: 'none' }}>
                        Already have an account?
                      </Typography> */}
                    </Grid>
                  </Grid>
                </Grid>
              </AuthCardWrapper>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
          <AuthFooter />
        </Grid>
      </Grid>
    </AuthWrapper1>
  );
};

export default ForgetPassword;
